import { getClientApplicationConfig } from '@hc-frontend/core-context';
import Image from 'next/image';

export default function TypConnectMeHolderContent() {
  const config = getClientApplicationConfig();
  const { marketplaceStaticBaseUrl } = config.assets;
  return (
    <div className="hc-stack-layout--large items-center">
      <h3 className="hc-typography--heading-three">
        Your call has been completed.
      </h3>
      <Image
        src={`${marketplaceStaticBaseUrl}/marketplace/images/typ-connect-me-holder-support.svg`}
        alt="Support"
        width={95}
        height={95}
      />
    </div>
  );
}
